import styled from 'styled-components'

export const QrContainer = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 5rem;
`

export const SaveBanner = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.small};
  margin-left: auto;
  margin-right: auto;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
`
